var reviews = require('../../services/reviews');

$(document.body).on('click', '.js-link-create', function (event) {
  var $this = $(this);
  var projectUrl = $this.attr('data-project-url');
  $('.js-create-project-modal')
    .find('.js-create-review-action')
    .attr('data-project-url', projectUrl);
});

$('html').on('click', function (e) {
  if (typeof $(e.target).data('original-title') === 'undefined' &&
     !$(e.target).parents().is('.popover.in')) {
    $('[data-original-title]').popover('hide');
  }
});

$(document.body).on('click', '.js-create-review-action', function (e) {
  e.preventDefault();
  var $this = $(this);
  $this.removeClass('error');
  $this.addClass('busy');

  var projectUrl = $this.attr('data-project-url');

  reviews.createAdvancedReview(projectUrl)
    .then(result => {
      window.location.href = result.redirect;
    })
    .catch(function () {
      $this.removeClass('busy');
      $this.addClass('error');
    });
});
